var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item",class:{
    'faq-item--expanded': _vm.isOpen,
  },on:{"click":_vm.toggle}},[_c('h3',{staticClass:"faq-item__question"},[_vm._v("\n    "+_vm._s(_vm.question)+"\n    "),_c('icon-arrow-down',{staticClass:"faq-item__toggle"})],1),_c('div',{staticClass:"faq-item__wrapper"},[_c('div',{staticClass:"faq-item__content",domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }